function Input({ label, id, type = 'text', className = '', ...props }) {
  return (
    <div className="w-full">
      {label && (
        <label htmlFor={id} className="mb-1 block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <input
        id={id}
        type={type}
        className={`min-h-[48px] w-full rounded-xl border border-gray-300 px-4 text-base text-gray-900 placeholder-gray-400 focus:border-green-600 focus:outline-none focus:ring-2 focus:ring-green-200 ${className}`}
        {...props}
      />
    </div>
  );
}

export default Input;
